var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 480",
    style: {
      enableBackground: "new 0 0 480 480"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF7059"
    },
    cx: 240,
    cy: 368,
    r: 40
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7059"
    },
    d: "M208,72h64v224h-64V72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7059"
    },
    d: "M232,0h16v48h-16V0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7059"
    },
    d: "M170.175,10.213l15.456-4.144l12.432,46.368l-15.456,4.144L170.175,10.213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7059"
    },
    d: "M113.071,36.151l13.856-8l23.999,41.569l-13.856,8L113.071,36.151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7059"
    },
    d: "M64.634,75.948l11.314-11.313l33.939,33.943l-11.314,11.313L64.634,75.948z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7059"
    },
    d: "M28.154,126.922l8-13.856l41.569,23.999l-8,13.856L28.154,126.922z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7059"
    },
    d: "M6.107,185.571l4.142-15.455l46.356,12.425l-4.142,15.455L6.107,185.571z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7059"
    },
    d: "M0,232h48v16H0V232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7059"
    },
    d: "M6.109,294.392l46.357-12.421l4.141,15.455L10.25,309.847L6.109,294.392z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7059"
    },
    d: "M28.16,353.069l41.571-23.996l7.999,13.857l-41.571,23.996L28.16,353.069z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7059"
    },
    d: "M64.613,404.036l33.941-33.941l11.314,11.314L75.927,415.35L64.613,404.036z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7059"
    },
    d: "M113.074,443.849l23.996-41.571l13.857,7.999l-23.996,41.571L113.074,443.849z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7059"
    },
    d: "M170.155,469.771l12.423-46.365l15.455,4.141l-12.423,46.365L170.155,469.771z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7059"
    },
    d: "M232,432h16v48h-16V432z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7059"
    },
    d: "M282.073,427.507l15.456-4.144l12.432,46.368l-15.456,4.144L282.073,427.507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7059"
    },
    d: "M329.07,410.289l13.857-8l23.999,41.569l-13.856,8L329.07,410.289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7059"
    },
    d: "M370.132,381.434l11.314-11.313l33.939,33.943l-11.314,11.313L370.132,381.434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7059"
    },
    d: "M402.266,342.902l8-13.856l41.569,23.999l-8,13.856L402.266,342.902z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7059"
    },
    d: "M423.389,297.414l4.142-15.455l46.356,12.425l-4.142,15.455L423.389,297.414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7059"
    },
    d: "M432,232h48v16h-48V232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7059"
    },
    d: "M423.386,182.577l46.357-12.421l4.141,15.455l-46.357,12.421L423.386,182.577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7059"
    },
    d: "M402.273,137.035l41.571-23.996l7.999,13.857l-41.571,23.996L402.273,137.035z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7059"
    },
    d: "M370.109,98.575l33.941-33.941l11.314,11.314l-33.941,33.941L370.109,98.575z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7059"
    },
    d: "M329.076,69.727l23.996-41.571l13.857,7.999l-23.996,41.571L329.076,69.727z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7059"
    },
    d: "M281.974,52.492l12.423-46.365l15.455,4.141l-12.423,46.365L281.974,52.492z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.d44c6d6e.svg";
export { ForwardRef as ReactComponent };